import endpoints from './endpoints';
import { apiAction } from './api';
import { nullAction } from './general';
var datefns = require('date-fns');
export const SET_CURRENT_MEETING = 'SET_CURRENT_MEETING';
//const caltest = require('../../../json/calendar.json');

export const getCurrentEvent = () => {
  return apiAction({
    url: endpoints.getCalendarEvents,
    data: {
      startdatetime: datefns.formatISO(new Date()),
      enddatetime: datefns.formatISO(datefns.addMinutes(new Date(), 10)),
    },
    onSuccess: (payload) => {
      const currentEvent =
        payload?.value?.find(
          (event) => event?.responseStatus?.response !== "declined"
        ) || null;

      return setCurrentEvent(currentEvent);
    },
    onFailure: [nullAction],
  });
};

export const setCurrentEvent = (data) => {
  return {
    type: SET_CURRENT_MEETING,
    payload: data,
  };
};

const initialState = {
  current: null,
};

//reducer
export const calendar = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_MEETING:
      return { ...state, current: action.payload };
    default:
      return state;
  }
};
